
export const DIALOG_EDGE_ALERT_CONTENT = "При использовании Microsoft Edge наблюдаются проблемы с загрузкой больших файлов. Мы рекомендуем использовать другой браузер для загрузки модов."
